const normalizeSrc = (src) => {
  return src.startsWith("http") ? src : src.startsWith("/") ? src : `/${src}`;
};

export default function cloudflareLoader({ src }) {
  return normalizeSrc(src);
}
